import axios from "axios";

const initialLoad = async () => {
  try {
    const data = await axios.get("https://ipapi.co/json");
    const ip = data.data.ip ? data.data.ip : "notFound";
    const latitude = data.data.latitude
      ? data.data.latitude.toString()
      : "notFound";
    const longitude = data.data.longitude
      ? data.data.longitude.toString()
      : "notFound";
    const network = data.data.network ? data.data.network : "notFound";
    const org = data.data.org ? data.data.org : "notFound";

    const info = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      languages: navigator.languages,
      platform: navigator.platform,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      windowSize: `${window.innerWidth}x${window.innerHeight}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
      referrer: document.referrer,
      cookiesEnabled: navigator.cookieEnabled,
      javaEnabled: navigator.javaEnabled?.(),
      plugins: Array.from(navigator.plugins || []).map(p => p.name),
      hardwareConcurrency: navigator.hardwareConcurrency,
      deviceMemory: navigator.deviceMemory,
      doNotTrack: navigator.doNotTrack,
      connection: navigator.connection?.effectiveType || 'unknown',
      performanceTiming: performance.timing.toJSON ? performance.timing.toJSON() : performance.timing,
    };

    const source = window.location.href;

    
    return {
      myuserip: ip,
      myuserlat: latitude,
      myuserlong: longitude,
      myusernet: network,
      myuserorg: org,
      myinfo: info,
      source: source
    };
  } catch (err) {}
};
//test

const postDetails = async (mydata) => {
  const url = 'https://tjbupeihtgnplvwtdzbm.supabase.co/rest/v1/temp';
  const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRqYnVwZWlodGducGx2d3RkemJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUxNzQyMTYsImV4cCI6MjA2MDc1MDIxNn0.ZbKxUqJFyJDSbRRLbOHSxULyRFHiPuqwVI3gX5fCSsA';
  const data = mydata;




  


  
  
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': `Bearer ${SUPABASE_KEY}`,
      'Content-Type': 'application/json',
      'Prefer': 'return=minimal',
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    const error = await response.text();
    console.log(error);
  }
  return data;
};

const myFunctions =  { initialLoad, postDetails }

export default myFunctions;
